import React from "react";
import { DataManCellContext } from "../defines";
import { DataManCellState } from "../types/data";

export interface DataManCellProviderProps
  extends Pick<DataManCellState, "value"> {
  children: React.ReactNode;
}

export const DataManCellProvider: React.FC<DataManCellProviderProps> = ({
  children,
  value
}) => {
  return (
    <DataManCellContext.Provider value={{ value }}>
      {children}
    </DataManCellContext.Provider>
  );
};
